/**
 * `templates` — modèles de documents (base galerie, 4.1 ; D10).
 */
import { z } from 'zod';
import { bilingueSchema, CHAMPS_DOCUMENT, idSchema, langueSchema, withAudit } from './commun.js';
/** Les documents qu'une galerie génère en un clic (6.1). */
export const CLES_MODELE = [
    'fiche_oeuvre',
    'certificat',
    'liste_prix',
    'facture',
    'avoir',
    'bon_depot',
    'bon_pret',
    'offre',
    'dossier_oeuvres',
    'dossier_artiste',
];
export const cleModeleSchema = z.enum(CLES_MODELE);
export const FORMATS_PAGE = ['A4', 'US_Letter'];
export const formatPageSchema = z.enum(FORMATS_PAGE);
/**
 * Qui signe un document de la galerie, et où il est fait.
 *
 * Porté par le modèle et non par chaque demande : une galerie signe ses
 * certificats de la même main, et redemander le nom du directeur à chaque
 * émission serait une invitation à la faute de frappe. La demande peut
 * toujours l'emporter, pour la signature exceptionnelle.
 */
export const signatureModeleSchema = z.object({
    nom: z.string().min(1),
    qualite: z.string().min(1).optional(),
});
export const templateSchema = withAudit(z.object({
    _id: idSchema,
    cle: cleModeleSchema,
    nom: z.string().min(1),
    logotypeMediaId: idSchema.optional(),
    entete: bilingueSchema.optional(),
    pied: bilingueSchema.optional(),
    mentions: z.array(bilingueSchema).default([]),
    policeTitre: z.string().optional(),
    policeTexte: z.string().optional(),
    langue: langueSchema.default('fr'),
    format: formatPageSchema.default('A4'),
    actif: z.boolean().default(true),
    // ── Ajouts de S4-c, tous facultatifs : un modèle réglé avant ce lot
    // reste valide, et sort aux formules standard des gabarits.
    /** Texte d'attestation d'un certificat ; à défaut, la formule du gabarit. */
    texteCertificat: bilingueSchema.optional(),
    /** Signataire des documents attestés (certificat). */
    signataire: signatureModeleSchema.optional(),
    /** Lieu d'émission imprimé avec la date : « Fait à Paris, le … ». */
    lieuEmission: z.string().min(1).optional(),
    /**
     * Les prix de ce document s'entendent-ils toutes taxes comprises ?
     *
     * Ne convertit rien — le réglage dit comment INTITULER la colonne. Une
     * galerie qui affiche des prix TTC en vitrine les veut TTC sur sa liste
     * de prix ; une autre, hors taxes. Aucune ne veut qu'Artosera devine.
     */
    prixTtc: z.boolean().default(false),
}));
export const templateCreationSchema = templateSchema.omit(CHAMPS_DOCUMENT);
export const templateMiseAJourSchema = templateCreationSchema.omit({ cle: true }).partial();
//# sourceMappingURL=templates.js.map